import { datadogRum } from "@datadog/browser-rum";
import {
  Button,
  Card,
  ClickAwayListener,
  Fab,
  Popper,
  Stack,
} from "@mui/material";
import { useMemo, useState } from "react";
import { IS_PRODUCTION } from "@/config";
import { DATADOG_ENABLED } from "@/utils/observability/const";
import { WrenchIcon } from "../common/icons";

export function MoxieDevTools() {
  if (IS_PRODUCTION) return null;

  return <MoxieDevToolsInner />;
}

function MoxieDevToolsInner() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [nextDevToolsPresent] = useState(() => {
    const portal = document.querySelector("nextjs-portal");
    if (!portal) return false;

    return !!portal.shadowRoot?.querySelector("[data-nextjs-dev-tools-button]");
  });

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const sessionReplayLink = datadogRum.getSessionReplayLink();

  const sections = useMemo(() => {
    return [
      DATADOG_ENABLED && (
        <Button
          key="datadog-rum"
          fullWidth
          size="small"
          href={sessionReplayLink}
          target="_blank"
          sx={{ borderRadius: 1.5 }}
        >
          View Datadog RUM Session
        </Button>
      ),
    ].filter(Boolean);
  }, [sessionReplayLink]);

  if (sections.length === 0) return null;

  return (
    <>
      <Fab
        onClick={handleClick}
        style={{
          position: "fixed",
          left: nextDevToolsPresent ? 78 : 20,
          bottom: 20,
          isolation: "isolate",
          width: 38,
          height: 38,
        }}
        color="primary"
      >
        <WrenchIcon />
      </Fab>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-start"
        modifiers={[
          {
            name: "offset",
            options: { offset: [0, 7] },
          },
        ]}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card variant="outlined" sx={{ width: 248, p: 0.75 }}>
            <Stack direction="column" spacing={0.75}>
              {sections}
            </Stack>
          </Card>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
